<template>
  <div class="settle-page">

    <!-- 入驻化化，不止于接单赚钱 -->
    <section id="img-0" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/productBg.png')">
      <div class="img0-content">
        <h1 class="img0-title">
          <span>入驻化化，不止于接单赚钱</span>
          <span>更树立您的口碑</span>
        </h1>
        <p class="img0-desc">
          <span>再小的个体都有自己的品牌，自主经营，免费入驻</span>
          <span>室内设计师、装修工人师傅（拆除、水电、泥瓦、木工、油漆等）均可入驻</span>
        </p>
        <img class="img0-img" src="https://obs.huahuaeco.com/official/product1.png" alt="">
      </div>
    </section>

    <!-- 加入化化平台的好处 -->
    <section id="img-1" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/productBg1.png')">
      <div class="img1-content">
        <h2 class="img1-title">加入化化平台的好处</h2>
        <p class="img1-desc">创建属于自己的店铺，自主经营管理，海量订单等您接</p>

        <div class="img1-grid">
          <img class="img1-img" src="https://obs.huahuaeco.com/official/settlein1.png" alt="">
          <article class="img1-card img1-card-lt">
            <h3>平台交易，收款有保障</h3>
            <p>客户先托管订单资金到平台，客户验收通过后，平台将资金结算至服务方钱包</p>
          </article>

          <article class="img1-card img1-card-rt">
            <h3>多重守护，接单更放心</h3>
            <p>全过程证据留痕+平台全程见证，能更有效的减少纠纷，保障服务方权益</p>
          </article>

          <article class="img1-card img1-card-lb">
            <h3>积累业绩，赢得客户</h3>
            <p>每次用心完成交易，不仅能赢得客户好评与信赖，还能获得更多订单，赚取更多收入</p>
          </article>

          <article class="img1-card img1-card-rb">
            <h3>展现自己，打造品牌</h3>
            <p>通过真实内容创作+用心服务客户，全面展现自己，助力品牌打造与变现</p>
          </article>
        </div>
      </div>
    </section>

    <!-- 如何加入平台 -->
    <section id="img-2" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/SettleIn/img2.png')">
      <div class="img2-content">
        <h2 class="img2-title">如何加入平台</h2>

        <div class="img2-grid">
          <div class="img2-steps" aria-label="入驻步骤">
            <article class="img2-step">
              <img src="https://obs.huahuaeco.com/official/SettleIn/num1.png" alt="步骤1" />
              <div class="img2-step-text">
                <h3>扫码注册</h3>
                <p>扫码打开小程序，选择“我是服务方”</p>
              </div>
            </article>

            <article class="img2-step">
              <img src="https://obs.huahuaeco.com/official/SettleIn/num2.png" alt="步骤2" />
              <div class="img2-step-text">
                <h3>填写信息</h3>
                <p>登记个人信息与技能信息</p>
              </div>
            </article>

            <article class="img2-step">
              <img src="https://obs.huahuaeco.com/official/SettleIn/num3.png" alt="步骤3" />
              <div class="img2-step-text">
                <h3>技能验证</h3>
                <p>学习平台规则，参与考试答题</p>
              </div>
            </article>

            <article class="img2-step">
              <img src="https://obs.huahuaeco.com/official/SettleIn/num4.png" alt="步骤4" />
              <div class="img2-step-text">
                <h3>开始接单</h3>
                <p>考试通过后，即可接单赚钱</p>
              </div>
            </article>
          </div>

          <aside class="img2-qr-card">
            <img src="https://obs.huahuaeco.com/official/SettleIn/qrcode.png" alt="微信扫码入驻" class="img2-qr-img" />
            <p>微信扫码入驻</p>
          </aside>
        </div>
      </div>
    </section>
    <section id="img-3" class="full-image" style="background-image:url('https://obs.huahuaeco.com/official/SettleIn/img3.png')">
      <div class="img3-content">
        <h2 class="img3-title">入驻接单常见问题</h2>

        <div class="img3-faq-list">
          <article class="img3-faq-item">
            <div class="img3-question-row">
              <img src="https://obs.huahuaeco.com/official/SettleIn/ask.png" alt="问" class="img3-ask-icon" />
              <h3>如何加入化化平台?</h3>
            </div>
            <p>答：微信扫码打开“化化”小程序，选择“我是服务方”按系统指引，提交入驻资料、实名认证、学习与考试答题，通过即可接单。</p>
          </article>

          <article class="img3-faq-item">
            <div class="img3-question-row">
              <img src="https://obs.huahuaeco.com/official/SettleIn/ask.png" alt="问" class="img3-ask-icon" />
              <h3>加入化化平台，需要什么条件?</h3>
            </div>
            <p>答：只要您是设计师、工人师傅（包含拆除、水电、泥瓦、木工、油漆等），具备装修设计或施工技能，能服务好客户，即可入驻平台。</p>
          </article>

          <article class="img3-faq-item">
            <div class="img3-question-row">
              <img src="https://obs.huahuaeco.com/official/SettleIn/ask.png" alt="问" class="img3-ask-icon" />
              <h3>加入平台后，怎么接单?</h3>
            </div>
            <p>答：有两种方式：</p>
            <p>报价抢单：在接单大厅，找到客户需求，提交报名，与业主沟通后，提交报价方案，客户确认下单后，即接单成功。</p>
            <p>邀请接单：客户主动找您下单，您确认接单，即接单成功。</p>
          </article>
        </div>
      </div>
    </section>
    <SeoStaticImages :images="seoImages" />
  </div>
</template>

<script>
import { useHead } from '@unhead/vue'
import { getPageHead } from '../utils/page-head'
import SeoStaticImages from '../components/SeoStaticImages.vue'
export default {
  name: 'SettleInPage',
  components: {
    SeoStaticImages
  },
    setup() {
    useHead(getPageHead('settleIn'))
  },
  data() {
    return {
      seoImages: [
        'https://obs.huahuaeco.com/official/productBg.png',
        'https://obs.huahuaeco.com/official/productBg1.png',
        'https://obs.huahuaeco.com/official/SettleIn/img2.png',
        'https://obs.huahuaeco.com/official/SettleIn/img3.png',
        'https://obs.huahuaeco.com/official/SettleIn/headerCode.png',
        'https://obs.huahuaeco.com/official/SettleIn/num1.png',
        'https://obs.huahuaeco.com/official/SettleIn/num2.png',
        'https://obs.huahuaeco.com/official/SettleIn/num3.png',
        'https://obs.huahuaeco.com/official/SettleIn/num4.png',
        'https://obs.huahuaeco.com/official/SettleIn/qrcode.png',
        'https://obs.huahuaeco.com/official/SettleIn/ask.png'
      ]
    }
  },
  methods: {
    
  }
  ,
  mounted() {
  },
  beforeUnmount() {
  }
}
</script>

<style scoped lang="scss">
.settle-page {
  overflow-x: hidden;
}

.hero {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 98px;
  text-align: center;
  position: relative;
  overflow: hidden;

  &-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    z-index: 0;
    pointer-events: none;
  }

  > :not(.hero-bg) {
    position: relative;
    z-index: 1;
  }
}

.header-code {
  width: 736px;
  height: 397px;
  margin: 0 auto;
  background-image: url('https://obs.huahuaeco.com/official/SettleIn/headerCode.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

#img-0 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 180px 24px 90px;
  height: auto;
  min-height: 80vh;
}

.img0-content {
  width: min(1200px, 100%);
  margin: 0 auto;
  text-align: center;
  padding: 0 24px;
}
.img0-img {
  width: 6.6667rem;
  margin-top: 60px;
}
.img0-title {
  margin: 0;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.35;

  span {
    display: block;
  }
}

.img0-desc {
  margin: 30px 0 0;
  color: #595959;
  font-size: 24px;
  line-height: 1.8;

  span {
    display: block;
  }
}

.img0-note {
  margin: 0;
  color: #3f3f46;
  font-size: 34px;
  font-weight: 500;
  line-height: 1.4;
}

#img-1 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 110px 24px 48px;
  position: relative;
}

.img1-content {
  width: min(1220px, 100%);
  margin: 0 auto;
  z-index: 1;
}

.img1-img {
  grid-area: center;
  justify-self: center;
  align-self: center;
  position: relative;
  width: min(100%, 5rem);
  height: auto;
  z-index: 0;
  pointer-events: none;
}

.img1-title {
  margin: 0;
  text-align: center;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.35;
}

.img1-desc {
  margin: 24px 0 0;
  text-align: center;
  color: #8c8c8c;
  font-size: 20px;
  line-height: 1.7;
}

.img1-grid {
  margin-top: 64px;
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(320px, 5rem) minmax(280px, 1fr);
  grid-template-areas:
    "lt center rt"
    "lb center rb";
  align-items: center;
  row-gap: 78px;
}
@media (max-width: 1300px) {
  .img1-grid { 
    grid-template-columns: minmax(280px, 1fr) minmax(220px, 28vw) minmax(280px, 1fr);
  }
}

.img1-card-lt { grid-area: lt; }
.img1-card-rt { grid-area: rt; }
.img1-card-lb { grid-area: lb; }
.img1-card-rb { grid-area: rb; }

.img1-card {
  background: rgba(255, 255, 255, 0.72);
  border-radius: 16px;
  padding: 22px 20px;
  box-shadow: 0 20px 40px 0 rgba(224, 229, 238, 0.20);
  h3 {
    margin: 0;
    color: #3a3a3a;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.4;
  }

  p {
    margin: 14px 0 0;
    color: #8c8c8c;
    font-size: 16px;
    line-height: 1.55;
  }
}

#img-2 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 130px 24px 86px;
  height: auto;
  min-height: 90vh;
}

.img2-content {
  width: min(1220px, 100%);
  margin: 0 auto;
}

.img2-title {
  margin: 0;
  text-align: center;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.35;
}

.img2-grid {
  margin-top: 56px;
  display: flex;
  justify-content: center;
  gap: 30px
}

.img2-steps {
  display: grid;
  gap: 22px;
  width: 450px;
}

.img2-step {
  display: flex;
  align-items: center;
  gap: 14px;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 16px;
  padding: 16px 18px;
  box-shadow: 0 20px 40px 0 rgba(224, 229, 238, 0.20);
  img {
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
  }
}

.img2-step-text {
  h3 {
    margin: 0;
    color: #3a3a3a;
    font-size: 22px;
    line-height: 1.35;
    font-weight: 400 !important;
  }

  p {
    margin: 10px 0 0;
    color: #8c8c8c;
    font-size: 24px;
    font-size: 16px;
    line-height: 1.55;
  }
}

.img2-qr-card {
  background: rgba(255, 255, 255, 0.72);
  border-radius: 16px;
  padding: 42px 26px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 20px 40px 0 rgba(224, 229, 238, 0.20);
  p {
    margin: 24px 0 0;
    color: #3f3f46;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.4;
  }
}

.img2-qr-img {
  width: min(100%, 220px);
  height: auto;
  display: block;
}

#img-3 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 96px 24px 64px;
  height: auto !important;
  min-height: 80vh !important;
  overflow: visible;
}

.img3-content {
  width: min(920px, 100%);
  margin: 0 auto;
}

.img3-title {
  margin: 0;
  text-align: center;
  color: #262626;
  font-size: 48px;
  font-weight: 600;
  line-height: 1.35;
}

.img3-faq-list {
  margin-top: 48px;
  display: grid;
  gap: 18px;
}

.img3-faq-item {
  background: rgba(255, 255, 255, 0.72);
  border-radius: 16px;
  padding: 16px 22px;
  box-shadow: 0 20px 40px 0 rgba(224, 229, 238, 0.20);
  p {
    margin: 12px 0 0;
    color: #8c8c8c;
    font-size: 16px;
    line-height: 1.6;
  }
}

.img3-question-row {
  display: flex;
  align-items: center;
  gap: 12px;

  h3 {
    margin: 0;
    color: #333;
    font-size: 22px;
    font-weight: 400 !important;
    line-height: 1.35;
  }
  p {
    font-size: 16px;
  }
}

.img3-ask-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
}


@media (max-width: 1300px) {
  #img-0,
  #img-1,
  #img-2,
  #img-3 {
    height: auto !important;
    min-height: auto !important;
    overflow: visible;
  }

  #img-0 {
    padding: 120px 40px 90px;
  }

  .img0-content,
  .img1-content,
  .img2-content,
  .img3-content {
    width: min(920px, calc(100% - 48px));
  }

  .img0-title,
  .img1-title,
  .img2-title,
  .img3-title {
    font-size: clamp(32px, 3.4vw, 44px);
  }

  .img0-desc,
  .img1-desc {
    font-size: clamp(17px, 1.7vw, 20px);
    line-height: 1.65;
  }

  #img-1 {
    padding: 72px 40px 56px;
  }

  .img1-grid {
    grid-template-columns: minmax(0, 1fr) minmax(220px, 28vw) minmax(0, 1fr);
    row-gap: 28px;
    column-gap: 22px;
    margin-top: 40px;
  }

  .img1-img {
    width: min(100%, 340px);
  }

  .img1-card {
    padding: 18px 18px;
  }

  #img-2 {
    padding: 72px 32px 86px;
  }

  .img2-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(180px, 230px);
    align-items: start;
    justify-content: center;
    gap: 24px;
    margin-top: 38px;
  }

  .img2-steps {
    width: auto;
    min-width: 0;
    gap: 18px;
  }

  .img2-step {
    min-width: 0;
    padding: 14px 16px;
  }

  .img2-step-text {
    min-width: 0;
  }

  .img2-step-text h3 {
    font-size: clamp(18px, 2.1vw, 22px);
  }

  .img2-step-text p {
    font-size: clamp(14px, 1.6vw, 16px);
  }

  .img2-qr-card {
    align-self: stretch;
    min-width: 0;
    padding: 26px 18px 20px;
  }

  .img2-qr-img {
    width: min(100%, 180px);
  }

  #img-3 {
    padding: 56px 32px 44px;
  }

  .img3-content {
    width: min(820px, calc(100% - 32px));
  }

  .img3-faq-list {
    margin-top: 28px;
    gap: 16px;
  }

  .img3-faq-item {
    padding: 14px 18px;
  }
}

@media (max-width: 900px) {
  .img0-content,
  .img1-content,
  .img2-content,
  .img3-content {
    width: min(720px, calc(100% - 32px));
  }

  #img-0 {
    padding: 96px 28px 72px;
  }

  #img-1,
  #img-2,
  #img-3 {
    padding: 56px 24px 64px;
  }

  .img1-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-areas:
      "center center"
      "lt rt"
      "lb rb";
    align-items: stretch;
    row-gap: 18px;
    column-gap: 14px;
    margin-top: 28px;
  }

  .img1-img {
    align-self: center;
    width: min(280px, 58vw);
    margin-bottom: 4px;
  }

  .img1-card {
    padding: 14px 14px;
  }

  .img1-card h3,
  .img3-question-row h3 {
    font-size: 19px;
  }

  .img1-card p,
  .img3-faq-item p {
    font-size: 14px;
  }

  .img2-grid {
    grid-template-columns: minmax(0, 1fr) minmax(140px, 170px);
    gap: 16px;
  }

  .img2-step {
    gap: 10px;
    padding: 12px 12px;
  }

  .img2-step img,
  .img3-ask-icon {
    width: 30px;
    height: 30px;
    flex-basis: 30px;
  }

  .img2-step-text h3 {
    font-size: 18px;
  }

  .img2-step-text p {
    margin-top: 6px;
    font-size: 13px;
  }

  .img2-qr-card {
    padding: 20px 12px 16px;
  }

  .img2-qr-img {
    width: min(100%, 140px);
  }

  .img2-qr-card p {
    margin-top: 12px;
    font-size: 15px;
  }

  .img3-faq-list {
    margin-top: 24px;
    gap: 12px;
  }

  .img3-faq-item {
    padding: 14px 14px;
  }
}

// @media (max-width: 900px) {
//   #img-0 {
//     padding-top: 88px;
//   }

//   .img0-title {
//     font-size: 34px;
//     line-height: 1.45;
//   }

//   .img0-desc {
//     margin-top: 16px;
//     font-size: 18px;
//     line-height: 1.8;
//   }

//   .img0-note-row {
//     margin-top: 64px;
//     width: 100%;
//     justify-content: center;
//     gap: 32px;
//     flex-wrap: wrap;
//   }

//   .img0-note {
//     font-size: 16px;
//   }

//   #img-1 {
//     padding: 86px 16px 28px;
//   }

//   .img1-title {
//     font-size: 30px;
//   }

//   .img1-desc {
//     margin-top: 14px;
//     font-size: 16px;
//   }

//   .img1-grid {
//     margin-top: 24px;
//     grid-template-columns: 1fr;
//     grid-template-areas:
//       "lt"
//       "rt"
//       "lb"
//       "rb";
//     row-gap: 12px;
//   }

//   .img1-card {
//     padding: 14px;
    
//     h3 {
//       font-size: 18px;
//     }

//     p {
//       margin-top: 8px;
//       font-size: 14px;
//     }
//   }

//   #img-2 {
//     padding: 86px 16px 24px;
//   }

//   .img2-title {
//     font-size: 36px;
//   }

//   .img2-grid {
//     margin-top: 24px;
//     display: flex;
//   }

//   .img2-steps {
//     gap: 12px;
//   }

//   .img2-step {
//     border-radius: 12px;
//     padding: 12px;
//     gap: 10px;

//     img {
//       width: 28px;
//       height: 28px;
//       flex-basis: 28px;
//     }
//   }

//   .img2-step-text {
//     h3 {
//       font-size: 22px;
//     }

//     p {
//       margin-top: 6px;
//       font-size: 14px;
//     }
//   }

//   .img2-qr-card {
//     border-radius: 12px;
//     padding: 20px 14px 14px;

//     p {
//       margin-top: 12px;
//       font-size: 18px;
//     }
//   }

//   .img2-qr-img {
//     width: 160px;
//   }

//   #img-3 {
//     padding: 86px 16px 24px;
//   }

//   .img3-title {
//     font-size: 32px;
//   }

//   .img3-faq-list {
//     margin-top: 22px;
//     gap: 12px;
//   }

//   .img3-faq-item {
//     border-radius: 12px;
//     padding: 12px 14px;

//     p {
//       margin-top: 8px;
//       font-size: 14px;
//     }
//   }

//   .img3-question-row {
//     gap: 8px;

//     h3 {
//       font-size: 22px;
//     }
//   }

//   .img3-ask-icon {
//     width: 28px;
//     height: 28px;
//     flex-basis: 28px;
//   }
// }
</style>
